import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const OAuthCallback = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { handleOAuthCallback } = useAuth();

  useEffect(() => {
    const processOAuth = async () => {
      try {
        await handleOAuthCallback(location.search);
        navigate("/dashboard");
      } catch (err) {
        console.error("OAuth callback error:", err);
        setError("Authentication failed. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    processOAuth();
  }, [handleOAuthCallback, location.search, navigate]);

  if (loading) {
    return (
      <div className="oauth-callback-container">
        <h2>Processing your login...</h2>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="oauth-callback-container">
        <h2>Authentication Error</h2>
        <p className="error-message">{error}</p>
        <button className="retry-button" onClick={() => navigate("/login")}>
          Return to Login
        </button>
      </div>
    );
  }

  return null;
};

export default OAuthCallback;
